import { styled, Typography } from '@mui/material';
import { SimpleTooltipContentProps } from './SimpleTooltipContent.props';

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
}));

const StyledParagraph = styled(Typography)({
  fontSize: '14px',
});

const SimpleTooltipContent = ({ title, defaultText }: SimpleTooltipContentProps) => (
  <>
    <StyledTitle>{title}</StyledTitle>

    <StyledParagraph>{defaultText}</StyledParagraph>
  </>
);

export default SimpleTooltipContent;
